import { render, staticRenderFns } from "./TimetableDetail.vue?vue&type=template&id=61d0b5ea"
import script from "../../controllers/timetable/timetable-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/timetable/timetable-detail.js?vue&type=script&lang=js&external"
import style0 from "./TimetableDetail.vue?vue&type=style&index=0&id=61d0b5ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports